import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Header = styled.b`
    ${FONTS.H5};
    margin-bottom: 12px;
    display: block;
`;

export const LinkPhone = styled.a`
    ${FONTS.MediumXS};
    color: ${COLORS.GRAY_DARK};
    transition: 0.25s;
    cursor: pointer;
    margin-bottom: 4px;

    &:hover {
        color: ${COLORS.TextPrimary};
    }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 14px;
    }
`;

export const LinkCallBack = styled.a`
    ${FONTS.MediumXXS};
    color: ${COLORS.Link};
    transition: 0.25s;
    cursor: pointer;

    &:hover {
        color: ${COLORS.TextPrimary};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.MediumXS};
    }
`;

export const LinkWithIcon = styled.a`
    ${FONTS.MediumXS};
    color: ${COLORS.Link};
    transition: 0.25s;
    margin-bottom: 14px;
    margin-top: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;

    & > img {
        margin-right: 8px;
    }

    &:hover {
        color: ${COLORS.Logo};
    }
`;

export const RowNav = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 20px;
    grid-gap: 16px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        justify-content: flex-start;
        grid-gap: 13%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: block;
        margin-bottom: 24px;

        & > *:nth-child(1) {
            margin-bottom: 8px;
        }
    }
`;

export const RowCallback = styled.div`
    display: flex;
    align-items: baseline;
    flex-direction: column;
    margin-bottom: 14px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: row;
        margin-bottom: 24px;
    }
`;

export const List = styled.ul`
    margin: 0;
    padding: 0;
    ${FONTS.XS};
    list-style: none;
    display: flex;
    flex-direction: column;
`;

export const ListItem = styled.li`
    list-style-type: none;
    display: block;
    line-height: 26px;
    margin-bottom: 2px;
    white-space: nowrap;
`;
